export const TRANSACTION_STATUS = {
  success: "SUCCESS",
  pending: "PENDING",
  errored: "ERRORED",
};

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
